<template>
	<button class="v-switch" :type="$attrs.type" :on-label="onLabel" :off-label="offLabel" :checked="value==onValue" @click="change" ref="input">
		<div class="v-switch-slider"></div>
	</button>
</template>

<script>
export default {
  props: {
    value: {
      default: null
    },
    onValue: {
      default: true
    },
    offValue: {
      default: false
    },
    onLabel: {
      default: null
    },
    offLabel: {
      default: null
    }
  },
  computed: {
    disabled() {
      return (
        ("disabled" in this.$attrs && isString(this.$attrs.disabled)) ||
        this.$attrs.disabled
      );
    }
  },
  methods: {
    async change() {
      if (!this.disabled) {
        let { value, onValue, offValue } = this,
          checked = value == onValue ? offValue : onValue;
        this.$emit("input", checked);
        if (isPromise(this.$listeners.change)) {
          await this.$listeners.change(checked);
        } else {
          this.$emit("change", checked);
        }
      }
    }
  }
};
</script>

<style lang="less">
.v-switch {
  padding: 0px;
  border: none;
  outline: none;
  margin: 6px 0px;
  cursor: pointer;
  font-size: 12px;
  color: #ffffff;
  padding: 0px 6px;
  min-height: 20px;
  max-height: 20px;
  line-height: 20px;
  position: relative;
  border-radius: 10px;
  vertical-align: middle;
  filter: grayscale(100%);
  background-color: #41b883;
  transition: 300ms;
  &::before {
    content: "";
    min-width: 15px;
    white-space: nowrap;
    display: inline-block;
  }
  &::after {
    min-width: 15px;
    visibility: visible;
    display: inline-block;
    content: attr(off-label);
  }
  > .v-switch-slider {
    margin: 2px;
    top: 0px;
    left: 0px;
    width: 16px;
    height: 16px;
    position: absolute;
    border-radius: 8px;
    background-color: #ffffff;
    transition: 300ms;
  }
  &:not([disabled]):active {
    > .v-switch-slider {
      transform: scale(0.7);
    }
  }
  &[checked] {
    filter: grayscale(0);
    &::before {
      visibility: visible;
      content: attr(on-label);
    }
    &::after {
      content: "";
      visibility: hidden;
    }
    > .v-switch-slider {
      left: calc(100% - 20px);
    }
    &:active {
      > .v-switch-slider {
        left: calc(100% - 20px);
      }
    }
  }
  &[type="square"] {
    border-radius: 4px;
    > .v-switch-slider {
      border-radius: 2px;
    }
  }
  &[type="overflow"] {
    width: 32px;
    height: 14px;
    margin: 4px;
    min-height: 10px;
    border-radius: 7px;
    > .v-switch-slider {
      width: 18px;
      height: 18px;
      margin: 0px;
      border-radius: 9px;
      transform: translate3d(-3px, -2px, 0);
      box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.4);
    }
    &:active {
      > .v-switch-slider {
        transform: translate3d(-3px, -2px, 0) scale(0.7);
      }
    }
    &[checked] {
      > .v-switch-slider {
        left: calc(100% - 12px);
      }
      &:active {
        > .v-switch-slider {
          left: calc(100% - 12px);
        }
      }
    }
  }
  &[disabled] {
    cursor: no-drop;
    filter: grayscale(100%) brightness(90%);
  }
}
</style>
